<mat-dialog-content>
  @if (data.title) {
    <div class="group-header">
      {{data.title}}
    </div>
  }

  @if (data.errors) {
    <div>
      @for (error of data.errors; track error) {
        <div>
          {{error}}
        </div>
      }
    </div>
  }

</mat-dialog-content>
<mat-dialog-actions class="hw-justify-content-center-important hw-margin-bottom-1rem hw-padding-bottom-1em-important justify-content: center;">
  <button mat-dialog-close mat-raised-button class="custom-next-button next-button-style custom-next-button-width" cdkFocusInitial>OK</button>
</mat-dialog-actions>
